/* MANHAUS — interacciones propias (vanilla JS) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.mh-reveal:not(.mh-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mh-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('mh-visible');
        io.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initCifras(root) {
    var els = (root || document).querySelectorAll('[data-mh-cifra]:not([data-mh-hecho])');
    if (!els.length) return;
    function animar(el) {
      el.setAttribute('data-mh-hecho', '');
      var fin = parseFloat(el.getAttribute('data-mh-cifra')) || 0;
      var sufijo = el.getAttribute('data-mh-sufijo') || '';
      if (reduce) { el.textContent = fin + sufijo; return; }
      var t0 = null, dur = 1800;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        var v = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        el.textContent = v + sufijo;
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { els.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        animar(e.target);
        io.unobserve(e.target);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var els = document.querySelectorAll('[data-mh-parallax]');
    if (!els.length || reduce) return;
    var ticking = false;
    function update() {
      els.forEach(function (el) {
        var k = parseFloat(el.getAttribute('data-mh-parallax')) || 0;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) return;
        el.style.transform = 'translate3d(0,' + (-r.top * k / 100).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function initTilt() {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    document.querySelectorAll('[data-mh-tilt]').forEach(function (el) {
      el.addEventListener('mousemove', function (ev) {
        var r = el.getBoundingClientRect();
        var x = (ev.clientX - r.left) / r.width - 0.5;
        var y = (ev.clientY - r.top) / r.height - 0.5;
        el.style.transform = 'perspective(900px) rotateY(' + (x * 5).toFixed(2) + 'deg) rotateX(' + (-y * 5).toFixed(2) + 'deg)';
      });
      el.addEventListener('mouseleave', function () { el.style.transform = ''; });
    });
  }

  /* Escena de video: el video avanza al ritmo del scroll */
  function initEscenas(root) {
    (root || document).querySelectorAll('[data-mh-escena]:not([data-mh-listo])').forEach(function (esc) {
      esc.setAttribute('data-mh-listo', '');
      var video = esc.querySelector('video');
      var pasos = [].slice.call(esc.querySelectorAll('.mh-escena__paso'));
      if (!video) return;
      var src = video.getAttribute('data-src');
      var modo = esc.getAttribute('data-mh-escena');

      if (modo === 'auto' || reduce) {
        video.src = src;
        if (reduce) { video.removeAttribute('autoplay'); video.loop = false; return; }
        video.play().catch(function () {});
        return;
      }

      // Cargamos el video entero en memoria para que el avance sea fluido
      function usar(url) {
        video.src = url;
        video.load();
        var p = video.play();
        if (p && p.then) p.then(function () { video.pause(); }).catch(function () {});
      }
      if (window.fetch && window.URL) {
        fetch(src).then(function (r) { return r.blob(); })
          .then(function (b) { usar(URL.createObjectURL(b)); })
          .catch(function () { usar(src); });
      } else { usar(src); }

      var objetivo = 0, actual = 0, animando = false;
      function progreso() {
        var r = esc.getBoundingClientRect();
        var total = r.height - window.innerHeight;
        if (total <= 0) return 0;
        return Math.min(Math.max(-r.top / total, 0), 1);
      }
      function pintarPasos(p) {
        var pc = p * 100;
        pasos.forEach(function (el) {
          var d = parseFloat(el.getAttribute('data-desde')) || 0;
          var h = parseFloat(el.getAttribute('data-hasta'));
          if (isNaN(h)) h = 100;
          var activo = pc >= d && (pc < h || (h >= 100 && pc >= 99.5));
          el.classList.toggle('mh-activo', activo);
          el.classList.toggle('mh-pasado', !activo && pc >= h);
        });
      }
      function bucle() {
        actual += (objetivo - actual) * 0.14;
        if (Math.abs(objetivo - actual) < 0.0008) actual = objetivo;
        esc.style.setProperty('--p', actual.toFixed(4));
        if (video.duration) {
          var t = actual * (video.duration - 0.05);
          if (Math.abs(video.currentTime - t) > 0.02 && !video.seeking) video.currentTime = t;
        }
        if (actual !== objetivo) requestAnimationFrame(bucle); else animando = false;
      }
      function alScroll() {
        objetivo = progreso();
        pintarPasos(objetivo);
        if (!animando) { animando = true; requestAnimationFrame(bucle); }
      }
      window.addEventListener('scroll', alScroll, { passive: true });
      window.addEventListener('resize', alScroll);
      video.addEventListener('loadedmetadata', alScroll);
      alScroll();
    });
  }

  /* Página de producto */
  function dinero(centavos, formato) {
    var n = (centavos || 0) / 100;
    function fmt(dec, mil, sepDec) {
      if (Math.round(n * 100) % 100 === 0) dec = 0;
      var p = n.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, mil);
      return p.join(sepDec);
    }
    return (formato || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return fmt(0, ',', '.');
      if (k === 'amount_with_comma_separator') return fmt(2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return fmt(0, '.', ',');
      if (k === 'amount_with_space_separator') return fmt(2, ' ', ',');
      if (k === 'amount_no_decimals_with_space_separator') return fmt(0, ' ', ',');
      if (k === 'amount_with_apostrophe_separator') return fmt(2, "'", '.');
      return fmt(2, ',', '.');
    });
  }

  function initPdp(root) {
    (root || document).querySelectorAll('[data-mh-pdp]:not([data-mh-listo])').forEach(function (pdp) {
      pdp.setAttribute('data-mh-listo', '');
      var datosEl = pdp.querySelector('[data-mh-variantes]');
      var datos = datosEl ? JSON.parse(datosEl.textContent) : { variantes: [] };
      var form = pdp.querySelector('form[action*="/cart/add"]');
      var inputId = pdp.querySelector('[data-mh-variante]');
      var addBtn = pdp.querySelector('[data-mh-add]');
      var addTxt = pdp.querySelector('[data-mh-add-texto]');
      var barra = pdp.querySelector('[data-mh-barra]');
      var barraBtn = pdp.querySelector('[data-mh-barra-add]');
      var pista = pdp.querySelector('[data-mh-pista]');
      var slides = pista ? [].slice.call(pista.children) : [];
      var minis = [].slice.call(pdp.querySelectorAll('[data-mh-ir]'));
      var actualEl = pdp.querySelector('[data-mh-actual]');

      /* ---- galería ---- */
      function irA(i) {
        if (!pista || !slides[i]) return;
        pista.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      }
      function indiceActual() { return pista ? Math.round(pista.scrollLeft / pista.clientWidth) : 0; }
      if (pista) {
        pista.addEventListener('scroll', function () {
          var i = indiceActual();
          minis.forEach(function (m, k) { m.classList.toggle('mh-activo', k === i); });
          if (actualEl) actualEl.textContent = i + 1;
        }, { passive: true });
        minis.forEach(function (m) { m.addEventListener('click', function () { irA(parseInt(m.getAttribute('data-mh-ir'), 10)); }); });
        var prev = pdp.querySelector('[data-mh-prev]'), next = pdp.querySelector('[data-mh-next]');
        if (prev) prev.addEventListener('click', function () { irA((indiceActual() - 1 + slides.length) % slides.length); });
        if (next) next.addEventListener('click', function () { irA((indiceActual() + 1) % slides.length); });
        // zoom al pasar el ratón (solo ordenador)
        if (window.matchMedia('(hover: hover)').matches) {
          slides.forEach(function (s) {
            s.addEventListener('mouseenter', function () { s.classList.add('mh-zoom'); });
            s.addEventListener('mouseleave', function () { s.classList.remove('mh-zoom'); });
            s.addEventListener('mousemove', function (ev) {
              var r = s.getBoundingClientRect();
              s.style.setProperty('--zx', ((ev.clientX - r.left) / r.width * 100) + '%');
              s.style.setProperty('--zy', ((ev.clientY - r.top) / r.height * 100) + '%');
            });
          });
        }
      }

      /* ---- variantes ---- */
      var radios = [].slice.call(pdp.querySelectorAll('[data-mh-opcion]'));
      function seleccion() {
        var sel = [];
        radios.forEach(function (r) { if (r.checked) sel[parseInt(r.getAttribute('data-mh-opcion'), 10)] = r.value; });
        return sel;
      }
      function buscar(sel) {
        return datos.variantes.find(function (v) { return v.opciones.every(function (o, i) { return sel[i] === undefined || o === sel[i]; }); });
      }
      function marcarAgotados(sel) {
        radios.forEach(function (r) {
          var i = parseInt(r.getAttribute('data-mh-opcion'), 10);
          var prueba = sel.slice(); prueba[i] = r.value;
          var v = buscar(prueba);
          r.parentElement.classList.toggle('mh-sin-stock', !v || !v.disponible);
        });
      }
      function actualizar() {
        var sel = seleccion();
        var v = buscar(sel);
        sel.forEach(function (val, i) { var el = pdp.querySelector('[data-mh-valor="' + i + '"]'); if (el) el.textContent = val; });
        marcarAgotados(sel);
        if (!v) {
          if (addBtn) addBtn.disabled = true;
          if (addTxt) addTxt.textContent = 'No disponible';
          return;
        }
        inputId.value = v.id;
        var precio = pdp.querySelector('[data-mh-precio-actual]'), antes = pdp.querySelector('[data-mh-precio-antes]'), ahorro = pdp.querySelector('[data-mh-ahorro]'), barraP = pdp.querySelector('[data-mh-precio-barra]');
        if (precio) precio.textContent = dinero(v.precio, datos.moneda);
        if (barraP) barraP.textContent = dinero(v.precio, datos.moneda);
        var oferta = v.antes > v.precio;
        if (antes) { antes.hidden = !oferta; antes.textContent = dinero(v.antes, datos.moneda); }
        if (ahorro) { ahorro.hidden = !oferta; ahorro.textContent = 'Ahorrás ' + dinero(v.antes - v.precio, datos.moneda); }
        if (addBtn) addBtn.disabled = !v.disponible;
        if (barraBtn) barraBtn.disabled = !v.disponible;
        var ya = pdp.querySelector('[data-mh-comprar-ya]');
        if (ya) ya.disabled = !v.disponible;
        if (addTxt) addTxt.textContent = v.disponible ? datos.textos.agregar : datos.textos.agotado;
        var stock = pdp.querySelector('[data-mh-stock]');
        if (stock) {
          var poco = v.stock !== null && v.stock > 0 && v.stock <= datos.textos.umbral;
          stock.hidden = !poco;
          if (poco) stock.lastChild.textContent = datos.textos.stock.replace('[n]', v.stock);
        }
        if (v.media) {
          var k = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.media; });
          if (k > -1) irA(k);
        }
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
      radios.forEach(function (r) { r.addEventListener('change', actualizar); });
      if (radios.length) marcarAgotados(seleccion());

      /* ---- cantidad ---- */
      var cant = pdp.querySelector('[data-mh-cantidad]');
      var menos = pdp.querySelector('[data-mh-menos]'), mas = pdp.querySelector('[data-mh-mas]');
      if (cant && menos) menos.addEventListener('click', function () { cant.value = Math.max(1, (parseInt(cant.value, 10) || 1) - 1); });
      if (cant && mas) mas.addEventListener('click', function () { cant.value = (parseInt(cant.value, 10) || 1) + 1; });

      /* ---- guía de tallas ---- */
      var guiaLink = pdp.querySelector('[data-mh-abrir-guia]');
      if (guiaLink) guiaLink.addEventListener('click', function (e) {
        var g = document.querySelector(guiaLink.getAttribute('href'));
        if (!g) return;
        e.preventDefault(); g.open = true; g.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      /* ---- agregar al carrito (abre el carrito lateral) ---- */
      var errorEl = pdp.querySelector('[data-mh-error]');
      if (form && addBtn) form.addEventListener('submit', function (e) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || !window.fetch) return; // sin carrito lateral: envío normal a /cart
        e.preventDefault();
        if (addBtn.disabled) return;
        addBtn.classList.add('mh-cargando');
        var textoPrevio = addTxt.textContent; addTxt.textContent = datos.textos.agregando;
        if (errorEl) errorEl.hidden = true;
        var fd = new FormData(form);
        fd.append('sections', 'cart-drawer,cart-icon-bubble');
        fd.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: fd
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; } return; }
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          if (drawer.renderContents) drawer.renderContents(res); else window.location = '/cart';
        }).catch(function () { form.submit(); })
          .finally(function () { addBtn.classList.remove('mh-cargando'); addTxt.textContent = textoPrevio; });
      });

      /* ---- comprar ahora: agrega al carrito y va directo al pago ---- */
      var yaBtn = pdp.querySelector('[data-mh-comprar-ya]');
      var yaTxt = pdp.querySelector('[data-mh-ya-texto]');
      function comprarYa(boton) {
        if (!form || (addBtn && addBtn.disabled)) return;
        var previo = boton.textContent;
        boton.classList.add('mh-cargando');
        if (boton === yaBtn && yaTxt) yaTxt.textContent = 'Un momento…'; else boton.textContent = 'Un momento…';
        if (errorEl) errorEl.hidden = true;
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', 'Accept': 'application/javascript' }, body: new FormData(form)
        }).then(function (r) { return r.json(); }).then(function (res) {
          if (res.status) { if (errorEl) { errorEl.textContent = res.description || res.message; errorEl.hidden = false; } throw new Error('carrito'); }
          window.location.href = '/checkout';
        }).catch(function () {
          boton.classList.remove('mh-cargando');
          if (boton === yaBtn && yaTxt) yaTxt.textContent = previo.trim(); else boton.textContent = previo;
        });
      }
      if (yaBtn) yaBtn.addEventListener('click', function () { comprarYa(yaBtn); });

      /* ---- barra fija en móvil ---- */
      if (barra && addBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          var fuera = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
          barra.classList.toggle('mh-visible', fuera);
        }).observe(yaBtn || addBtn);
        if (barraBtn) barraBtn.addEventListener('click', function () {
          if (barraBtn.getAttribute('data-mh-barra-modo') === 'ya') { comprarYa(barraBtn); return; }
          if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
        });
      }
    });

    document.querySelectorAll('[data-mh-subir]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); var t = document.querySelector('[data-mh-pdp]'); if (t) t.scrollIntoView({ behavior: 'smooth' }); });
    });
  }

  function initTodo(root) { initReveals(root); initCifras(root); initEscenas(root); initPdp(root); }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document);
    initParallax();
    initTilt();
  });
  // Editor de Shopify: re-inicializar al añadir/editar secciones
  document.addEventListener('shopify:section:load', function (e) { initTodo(e.target); });
})();
